
import Vue from "vue";
import rules from "@/services/helpers/validation-rules";
import API from "@/api/API";
import store from "@/store";

export default Vue.extend({
  name: "Create",

  data: () => ({
    rules,
    model: {},
    errorMessages: {} as { [value: string]: Array<string> },
    categories: [] as Array<any>
  }),

  async beforeRouteEnter(to, from, next) {
    try {
      const categories = await API.goodsCategories().getList();

      next(vm => {
        vm.categories = categories.filter(
          (item: any) => item.value !== Number(to.params.id)
        );
      });
    } catch (e) {
      await store.dispatch("alert/showError", e.message);
    }
  },

  methods: {
    async submit(): Promise<void> {
      try {
        if ((this.$refs.form as Vue).validate()) {
          await this.$API.goodsCategories().create(this.model);
          await this.$router.push("/goods-categories");
          await this.$store.dispatch(
            "alert/showSuccess",
            this.$t("global_alert.successful_create")
          );
        }
      } catch (e) {
        if (e.hasOwnProperty("errors")) {
          this.errorMessages = e.errors;

          setTimeout(() => {
            this.errorMessages = {};
          }, 2000);
        }
        await this.$store.dispatch("alert/showError", e.message);
      }
    }
  }
});
